export const ResponseType = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
